/**
 * Contiene los componentes de textos editables por defecto en caso que falle el llamado al servicio
 */
const defaultComponents = {
    "componentes": [
        {
            "botones": [
                {
                    "nombre": "boton-cancelar-ao",
                    "texto": "Cancelar"
                },
                {
                    "nombre": "boton-solicitar-ao",
                    "texto": "Solicitar asistencia"
                }
            ],
            "componente": "Asistencia ofrecida",
            "subtitulo": "",
            "titulo": "De acuerdo con los síntomas informados, podemos ofrecerte:"
        },
        {
            "botones": [
                {
                    "nombre": "boton-ver-detalle-aov",
                    "texto": "Ver detalle"
                }
            ],
            "componente": "Asistencia ofrecida virtual",
            "subtitulo": "Nuestros profesionales pueden diagnosticar, recetar medicamentos y realizar constancias de atención y de alta",
            "titulo": ""
        },
        {
            "botones": [
                {
                    "nombre": "boton-ver-detalle-aod",
                    "texto": "Ver detalle"
                }
            ],
            "componente": "Asistencia ofrecida domicilio",
            "subtitulo": "El servicio puede presentar demoras adicionales durante todo el dia",
            "titulo": ""
        },
        {
            "botones": [
                {
                    "nombre": "volver-inicio-ac",
                    "texto": "Volver al inicio"
                },
                {
                    "nombre": "seguimiento-ac",
                    "texto": "Ir a seguimiento"
                }
            ],
            "componente": "Asistencia creada",
            "subtitulo": "Estamos gestionando tu solicitud para",
            "titulo": "Asistencia médica solicitada"
        },
        {
            "botones": [
                {
                    "nombre": "volver-error-tecnico",
                    "texto": "Volver a inicio"
                },
                {
                    "nombre": "contactanos-error-tecnico",
                    "texto": "Contactanos"
                }
            ],
            "componente": "Asistencia error técnico",
            "subtitulo": "Estamos trabajando para resolverlo. Podes contactarnos a través de whatsapp o llamada telefónica",
            "titulo": "Tuvimos un problema técnico"
        },
        {
            "botones": [
                {
                    "nombre": "cancelar-no",
                    "texto": "Mejor no"
                },
                {
                    "nombre": "cancelar-si",
                    "texto": "Sí, cancelar"
                }
            ],
            "componente": "Cancelar",
            "subtitulo": "En caso de hacerlo, vas a perder los datos cargados para esta solicitud, por lo tanto, no se realizará",
            "titulo": "¿Querés cancelar?"
        },
        {
            "botones": [
                {
                    "nombre": "sin-conexion-credencial",
                    "texto": "Ver credenciales"
                },
                {
                    "nombre": "sin-conexion-reintentar",
                    "texto": "Reintentar"
                },
                {
                    "nombre": "sin-conexion-telefonos",
                    "texto": "Ver teléfonos"
                }
            ],
            "componente": "Sin conexión",
            "subtitulo": "Detectamos que no tenes internet, pero pódes acceder a Ver credenciales en caso de que necesites utilizarlas.",
            "titulo": "Usá tus credenciales sin conexión"
        },
        {
            "botones": [
                {
                    "nombre": "contactanos-whatsapp",
                    "texto": "Escribinos por Whatsapp"
                },
                {
                    "nombre": "contactanos-tel1",
                    "texto": "0810.888.7788"
                },
                {
                    "nombre": "contactanos-tel2",
                    "texto": "0810.999.6300"
                },
                {
                    "nombre": "contactanos-riesgo-vida",
                    "texto": "0810.666.1111"
                }
            ],
            "componente": "modal-contactanos",
            "subtitulo": "",
            "titulo": "Contactanos"
        },
        {
            "botones": [
                {
                    "nombre": "informacion-tel1",
                    "texto": "0810.888.7788"
                },
                {
                    "nombre": "informacion-tel2",
                    "texto": "0810.999.6300"
                }
            ],
            "componente": "modal-whatsapp-saliente",
            "subtitulo": "Para brindarte una mejor asistencia, será necesario que te contactes directamente con nosotros.",
            "titulo": "Información importante"
        },
        {
            "botones": [
                {
                    "nombre": "no-encuentro-whatsapp",
                    "texto": "Escribinos por Whatsapp"
                },
                {
                    "nombre": "no-encuentro-tel1",
                    "texto": "0810.888.7788"
                },
                {
                    "nombre": "no-encuentro-tel2",
                    "texto": "0810.999.6300"
                }
            ],
            "componente": "modal-no-encuentro-sintoma",
            "subtitulo": "Para brindarte una mejor asistencia, será necesario que te contactes directamente con nosotros.",
            "titulo": "Información importante"
        },
        {
            "botones": [
                {
                    "nombre": "carrito-menor-whatsapp",
                    "texto": "Escribinos por Whatsapp"
                },
                {
                    "nombre": "carrito-menor-tel1",
                    "texto": "0810.888.7788"
                },
                {
                    "nombre": "carrito-menor-tel2",
                    "texto": "0810.999.6300"
                }
            ],
            "componente": "modal-carrito-menor",
            "subtitulo": "Para brindarte una mejor asistencia, será necesario que te contactes directamente con nosotros.",
            "titulo": "Información importante"
        },
        {
            "botones": [
                {
                    "nombre": "disponibilidad-zona-whatsapp",
                    "texto": "Escribinos por Whatsapp"
                },
                {
                    "nombre": "disponibilidad-zona-tel1",
                    "texto": "0810.888.7788"
                },
                {
                    "nombre": "disponibilidad-zona-tel2",
                    "texto": "0810.999.6300"
                }
            ],
            "componente": "modal-disponibilidad-zona",
            "subtitulo": "Para brindarte una mejor asistencia, será necesario que te contactes directamente con nosotros.",
            "titulo": "Información importante"
        },
        {
            "botones": [
                {
                    "nombre": "volver-inicio-ec",
                    "texto": "Volver al inicio"
                },
                {
                    "nombre": "contactanos-ec",
                    "texto": "Contactanos"
                }
            ],
            "componente": "Asistencia error en curso",
            "subtitulo": "Ya existe una solicitud para $nombre. En caso de que necesites realizar una consulta, podés contactarnos",
            "titulo": "Existe una solicitud en curso"
        }
    ]
}

export const inicializarTextosComponentes = () => {
    return defaultComponents;
}

/**
 * Contiene la deshabilitacion de versiones por defecto en caso que falle el request
 */
const defaultDeshabilitacionVersiones = {
    "aplicacion": "web",
    "version": "3.9.0",
    "deshabilitarControlVerdes": false,
    "deshabilitarGeolocalizacion": false,
    "deshabilitarGeolocalizacionExacta": false,
    "deshabilitarServiciosMultiples": false,
    "deshabilitarValidacionPlan": false,
    "deshabilitarWhatsappEmergencia": false,
    "deshabilitarWhatsappMenorMeses": false,
    "deshabilitarWhatsappNoEncuentroSintoma": false,
    "deshabilitarWhatsappZona": false
}

export const inicializarDeshabilitarVersiones = () => {
    return defaultDeshabilitacionVersiones
}

/**
 * Contiene la deshabilitacion de versiones por defecto en caso que falle el request en ysocial
 */
const defaultDeshabilitacionVersionesYsocial = {
    "aplicacion": "ysocial",
    "version": "3.9.0",
    "deshabilitarControlVerdes": false,
    "deshabilitarGeolocalizacion": false,
    "deshabilitarGeolocalizacionExacta": false,
    "deshabilitarValidacionPlan": false
}

export const inicializarDeshabilitarVersionesYsocial = () => {
    return defaultDeshabilitacionVersionesYsocial
}